import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { Software } from '@/services/software-select.service'

@Injectable()
export class RangeSettingService {
  constructor (private http: Http) {
  }

  getSoftConfig () {
    return this.http.post<{ data: Software[] }>('/softmgr/userecord/config-get', {})
  }

  setSoftConfig (data: { software_ids: number[] }) {
    return this.http.post('/softmgr/userecord/config-save', data)
  }
}
